"use strict";
exports.__esModule = true;
exports.SvgRecent = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgRecent = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 20 20", fill: "none" }, props),
    react_1["default"].createElement("path", { d: "M9.773 6.766v3.746l2.945 1.796M7.226 3.304a7.248 7.248 0 115.547 13.392A7.248 7.248 0 017.226 3.304z", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }))); };
//# sourceMappingURL=Recent.js.map